import { Pipe, PipeTransform } from "@angular/core";
import { EncuestaDTO } from "@DTOS";

@Pipe({
    name: "estadoEncuesta"
})
export class EstadoEncuestaPipe implements PipeTransform {

    transform(encuesta: EncuestaDTO): string {
        if (encuesta.cantidadBugsSinResolver !== 0) {
            return `Tiene ${encuesta.cantidadBugsSinResolver} sin resolver`;
        } else {
            if (encuesta.aprobadoPor) {
                return `Aprobado por ${encuesta.aprobadoPor}`;
            } else {
                return "No tiene bugs sin resolver";
            }
        }
    }

}
